import { api } from './api'

export interface CreateProjectRequest {
  name: string
  client_name?: string
  project_type?: string
  status?: string
  start_date?: string
  end_date?: string
  contract_value?: number
  address?: string
  city?: string
  state?: string
  zip_code?: string
  organization_id?: string
}

export interface ProjectResponse {
  id: string
  organization_id: string
  name: string
  client_name?: string
  project_type?: string
  status: string
  start_date?: string
  end_date?: string
  contract_value?: number
  created_at: string
  is_sample?: boolean
  city?: string
  state?: string
}

export interface Project {
  id: string
  organization_id: string
  name: string
  client_name?: string
  description?: string
  address?: string
  city?: string
  state?: string
  zipcode?: string
  location_lat?: number
  location_lng?: number
  contract_value?: number
  start_date?: string
  end_date?: string
  status?: string
  created_at: string
  updated_at: string
  require_lawyer_approval?: boolean
  allow_pm_approval?: boolean
  project_manager_id?: string
  is_sample?: boolean
}

export interface TeamMember {
  id: string
  email: string
  first_name?: string
  last_name?: string
  role: string
  status: string
}

class ProjectService {
  async createProject(data: CreateProjectRequest): Promise<ProjectResponse> {
    try {
      const response = await api.post('/projects', data)
      return response.data
    } catch (error) {
      console.error('Failed to create project:', error)
      throw error
    }
  }

  async getProjects(): Promise<ProjectResponse[]> {
    try {
      const response = await api.get('/projects')
      return response.data
    } catch (error) {
      console.error('Failed to fetch projects:', error)
      throw error
    }
  }

  async getProject(id: string): Promise<Project> {
    try {
      const response = await api.get(`/projects/${id}`)
      return response.data
    } catch (error) {
      console.error('Failed to fetch project:', error)
      throw error
    }
  }

  async updateProject(id: string, data: Partial<CreateProjectRequest>): Promise<ProjectResponse> {
    try {
      const response = await api.put(`/projects/${id}`, data)
      return response.data
    } catch (error) {
      console.error('Failed to update project:', error)
      throw error
    }
  }

  async deleteProject(id: string): Promise<void> {
    try {
      await api.delete(`/projects/${id}`)
    } catch (error) {
      console.error('Failed to delete project:', error)
      throw error
    }
  }

  async getTeam(projectId: string): Promise<TeamMember[]> {
    const response = await api.get(`/projects/${projectId}/team`)
    return response.data
  }

  async inviteMember(projectId: string, email: string, role: string): Promise<void> {
    await api.post(`/projects/${projectId}/team`, { email, role })
  }
}

export const projectService = new ProjectService()